
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.007 8.695c-4.348 0-4-5.74-4-6.956H3.18M17.007 8.695c4.348 0 4.087-5.74 4.087-6.956h-2.261"}}),_c('path',{attrs:{"d":"M18.833 0H3.18c0 13.391 6.956 9.652 6.956 14.348-.087 3.043-1.478 3.913-3.913 3.913V20h9.565v-1.74c-2.434 0-3.913-.869-3.913-3.912 0-4.783 6.957-.957 6.957-14.348z"}})])
          )
        }
      }
    